<form [formGroup]="formGroup" (submit)="submit()">
    <div class="modal-header">
        <h5 class="modal-title">{{ 'reporting_CHANGE_EMAIL' | translate }}</h5>
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="activeModal.dismiss('Cancel')"></button>
    </div>

    <div class="modal-body">
        <app-input-text-group
            [label]="'common_email_address' | translate: 'online' : 'common'"
            formControlName="email" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="activeModal.dismiss('Cancel')">
            {{ 'reporting_CANCEL' | translate }}
        </button>
        <button type="submit" class="btn btn-primary">
            {{ 'reporting_SAVE' | translate }}
        </button>
    </div>
</form>
